import { render } from "./acceptwallet.vue?vue&type=template&id=11a054d9&scoped=true"
import script from "./acceptwallet.vue?vue&type=script&lang=js"
export * from "./acceptwallet.vue?vue&type=script&lang=js"

import "./acceptwallet.vue?vue&type=style&index=0&id=11a054d9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11a054d9"]])

export default __exports__